export type ReviewsFiltersForm = {
  reviewAtFrom: Date | null;
  reviewAtTo: Date | null;
  candidateId: string | null;
  companyId: string | null;
  vacancy: string;
};

export const REVIEWS_FILTERS_INITIAL: ReviewsFiltersForm = {
  reviewAtFrom: null,
  reviewAtTo: null,
  candidateId: null,
  companyId: null,
  vacancy: '',
};

export type ReviewsListFilter = {
  reviewAtFrom?: string;
  reviewAtTo?: string;
  company?: { items: string[]; operator: 'or' };
  vacancy?: { items: string[]; operator: 'or' };
  candidateFirstname?: { items: string[]; operator: 'or' };
  candidateLastname?: { items: string[]; operator: 'or' };
};
